var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67881 0.720016C8.83041 0.568141 9.00253 0.435937 9.00253 0.28125C9.00253 0.126562 8.87681 0 8.72128 0H5.90878C5.87475 0 5.62753 0 5.62753 0.28125V3.09375C5.62753 3.24844 5.75353 3.375 5.90878 3.375C6.06431 3.375 6.17259 3.22595 6.29241 3.10783L7.074 2.32594C7.57181 2.91376 7.875 3.67031 7.875 4.5C7.875 6.36469 6.36384 7.875 4.5 7.875C2.63616 7.875 1.125 6.36469 1.125 4.5C1.125 2.82938 2.34197 1.44283 3.9375 1.17564V0.0393791C1.71816 0.315004 0 2.205 0 4.5C0 6.98625 2.01487 9 4.5 9C6.98513 9 9 6.98625 9 4.5C9 3.35812 8.57362 2.32033 7.87303 1.5272L8.67881 0.720016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1813d475dfc35da18efcd272ef5ffcbc.svg";
export { ForwardRef as ReactComponent };